module.exports = __webpack_public_path__ + "static/img/qiangcha2.094b0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/qiangcha2.png
// module id = ZkZc
// module chunks = 24